import {BaseDomainDataSource} from "../../infrastructure/models/base-domain-data-source";
import {AthleteEventsChartResponseApiModel} from "./athlete-events-chart-response.api-model";
import {
  AthleteChartEventsDomainModel
} from "../full-game/models/chart-events/athlete-chart-events/athlete-chart-events.domain-model";

export class AthleteEventsChartDataSource extends BaseDomainDataSource {
  apiModel: AthleteEventsChartResponseApiModel;
  chartEventsModels: Array<AthleteChartEventsDomainModel>;


  constructor(apiModel: AthleteEventsChartResponseApiModel, chartEventsModels: Array<AthleteChartEventsDomainModel>) {
    super(apiModel);

    this.chartEventsModels = chartEventsModels;
  }
}